import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { FaLock } from "react-icons/fa";
import { useUserContext } from "../../UserContext";
import { ThemeChooser } from "../../utils";
import { PasswordField } from "../../controls";

export const LoginPage = () => {
  const { login } = useUserContext();

  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    try {
      await login(data.get("email") as string, data.get("password") as string);
    } catch (err: any) {
      setErrorMessage(err?.response?.message ?? err?.message);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <ThemeChooser sx={{ display: "inline", float: "right" }} />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <FaLock />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField margin="normal" required fullWidth id="email" label="Email Address" name="email" autoComplete="email" autoFocus />
          <TextField type="password" margin="normal" required fullWidth name="password" label="Password" id="password" />
          <Typography component="p" sx={{ color: "error.main" }}>
            {errorMessage}
          </Typography>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Sign In
          </Button>
          <Grid container></Grid>
        </Box>
      </Box>
    </Container>
  );
};
